module.exports = __webpack_public_path__ + "img/img_slide_8.153de1df.webp";